import { render, staticRenderFns } from "./CreatePaymentsBody.vue?vue&type=template&id=43826aca&"
import script from "./CreatePaymentsBody.vue?vue&type=script&lang=ts&"
export * from "./CreatePaymentsBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports